/** @jsx jsx */

import { useContext } from 'react';
import { css, jsx } from '@emotion/core';
import GraphCircle from './GraphCircle';
import GraphBar from './GraphBar';
import { interactionContext as _interactionContext } from './interactionContext';

const GraphContainer = () => {
  const interactionContext = useContext(_interactionContext);
  const { score } = interactionContext;
  const {
    graphType,
    graphColor,
    graphTextColor = '#000',
  } = interactionContext.props;

  return (
    <div
      css={css`
        display: flex;
        justify-content: center;
        align-items: center;
        width: 100%;
        padding: 30px;
      `}
    >
      {graphType === 'circle' ? (
        <GraphCircle
          color={graphColor}
          textColor={graphTextColor}
          score={Number(score)}
        />
      ) : (
        <GraphBar
          color={graphColor}
          textColor={graphTextColor}
          score={Number(score)}
        />
      )}
    </div>
  );
};

export default GraphContainer;
